import React from 'react';
import loadable from '@loadable/component';
import CategorySvgs from 'core/svg/category';
import StarNewArrivals from 'core/icons/StarNewArrivals';
const GiftBox = loadable(() => import('core/icons/GiftBox'));
// Holiday logo (not used)
// const GiftBox = loadable(() => import('core/icons/HolidayGiftIcon'));

const Facebook = loadable(() => import(
	/* webpackChunkName: "AsyncSocialIcons" */
	'core/icons/Facebook'
));
const Instagram = loadable(() => import(
	/* webpackChunkName: "AsyncSocialIcons" */
	'core/icons/Instagram'
));
const Twitter = loadable(() => import(
	/* webpackChunkName: "AsyncSocialIcons" */
	'core/icons/Twitter'
));
const Pinterest = loadable(() => import(
	/* webpackChunkName: "AsyncSocialIcons" */
	'core/icons/Pinterest'
));
const Youtube = loadable(() => import(
	/* webpackChunkName: "AsyncSocialIcons" */
	'core/icons/Youtube'
));

const Tiktok = loadable(() => import(
	/* webpackChunkName: "AsyncSocialIcons" */
	'core/icons/Tiktok'
));

export const svgMap = {
	'subscription-boxes-for-men': CategorySvgs.Men,
	'beauty-fashion-subscription-boxes': CategorySvgs.Beauty,
	'book-subscription-boxes': CategorySvgs.Books,
	'subscription-boxes-for-women': CategorySvgs.Women,
	'food-subscription-boxes': CategorySvgs.FoodAndBeverage,
	'geek-gaming-subscription-boxes': CategorySvgs.GeekAndGaming, // TODO: remove this once category_family is reslugged to fun-subscription-boxes.
	'fun-subscription-boxes': CategorySvgs.GeekAndGaming,
	'fitness-health-subscription-boxes': CategorySvgs.Fitness,
	'family-kids-subscription-boxes': CategorySvgs.Kids,
	'animals-pets-subscription-boxes': CategorySvgs.Pets,
	'arts-and-craft-subscription-boxes': CategorySvgs.ArtsAndCrafts,
	'home-garden-subscription-boxes': CategorySvgs.Home,
	'novelty-subscription-boxes': CategorySvgs.Novelty,
	'spiritual-subscription-boxes': CategorySvgs.Spiritual,
	'collections': CategorySvgs.Collections,
	'gifting': GiftBox,
	'new-arrivals': StarNewArrivals,
	'kids': CategorySvgs.Kids,
	'self-care-gifts-subscription-boxes': CategorySvgs.Beauty,
	'Facebook': Facebook,
	'Instagram': Instagram,
	'Twitter': Twitter,
	'Pinterest': Pinterest,
	'Youtube': Youtube,
	'Tiktok': Tiktok,
};
